var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputerParts = function SvgComputerParts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.763 19a2.98 2.98 0 0 1-.722-1.5H5.75a.75.75 0 0 0-.75.75c0 .416.334.75.75.75zM4 5c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h7v-1.5H4a.5.5 0 0 1-.5-.5V7c0-.275.225-.5.5-.5h7.04a3 3 0 0 1 .723-1.5zm16 1.5c.275 0 .5.225.5.5v10c0 .275-.225.5-.5.5h-6a.5.5 0 0 1-.5-.5V7c0-.275.225-.5.5-.5zM14 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm3 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M16 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
  })));
};
export default SvgComputerParts;